import { render } from "./Phone.vue?vue&type=template&id=a4533f80&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"

import "@/assets/styles/components/collections/form/phone.styl?vue&type=style&index=0&id=a4533f80&lang=stylus&scoped=true"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4533f80"]])

export default __exports__